export const HOME_ROUTE = "/";
export const CREATE_SIGNAL_ROUTE = "/signal/create";
export const SIGNAL_DETAIL_ROUTE = "/signal/:id/detail";
export const SIGNAL_DETAIL_MAP = "/signal/map";
